import { render, staticRenderFns } from "./descriptions.vue?vue&type=template&id=1e2d5496&scoped=true"
import script from "./descriptions.vue?vue&type=script&lang=js"
export * from "./descriptions.vue?vue&type=script&lang=js"
import style0 from "./descriptions.vue?vue&type=style&index=0&id=1e2d5496&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2d5496",
  null
  
)

export default component.exports